// The two answers on the empty page — "I am currently employed" and "I am not".
//
// A question with two answers rather than a blank form, so the first thing a
// driver meets is something they can answer without reading a label.

import { ChevronRight } from 'lucide-react'

export interface ChoiceRowProps {
  label: string
  /** The expected answer, given a lift so the page has an obvious first move. */
  emphasis?: boolean
  onSelect: () => void
}

const join = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ')

export const ChoiceRow = ({
  label,
  emphasis = false,
  onSelect,
}: ChoiceRowProps) => (
  <button
    type="button"
    onClick={onSelect}
    data-emphasis={emphasis || undefined}
    className={join(
      'flex w-full items-center justify-between gap-2.5 rounded-[10px] border p-[13px] text-left shadow-sm',
      emphasis
        ? 'border-doubleNickel-brand-500 bg-doubleNickel-brand-25'
        : 'border-doubleNickel-gray-300 bg-white'
    )}
  >
    <span
      className={join(
        'text-[13.5px] font-semibold',
        emphasis ? 'text-doubleNickel-brand-700' : 'text-doubleNickel-gray-900'
      )}
    >
      {label}
    </span>
    <ChevronRight
      size={16}
      className={
        emphasis ? 'text-doubleNickel-brand-600' : 'text-doubleNickel-gray-400'
      }
    />
  </button>
)
